import React, { forwardRef } from 'react';
import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import { FocusStyles } from '../../styles/FocusStyles';
import useHasReactRouterContext from '../../hooks/useHasReactRouterContext';
const FocusLinkButtonTextStyles = css `
  font-family: ${props => props.theme.fonts.serif};
  font-weight: 500;
  cursor: pointer;
  text-decoration: none;
`;
export const LinkWithOutline = styled.a `
  color: ${props => props.theme.Black};
  display: inline-block;
  text-decoration: none;
  ${FocusStyles}

  &:hover {
    color: ${props => props.theme.colors.primary};
  }
`;
export const FocusTextLink = styled.a `
  display: inline-flex;
  ${FocusLinkButtonTextStyles}
  font-size: ${({ isMobile }) => (isMobile ? '1.125rem' : '1.25rem')};
  align-items: center;
  color: ${({ isCrossLink, theme }) => isCrossLink ? theme.colors.primary : theme.colors.darkergrey};

  ${FocusStyles};

  &:hover {
    color: ${({ isCrossLink, theme }) => isCrossLink ? theme.colors['primary-hover'] : theme.colors.primary};
  }
`;
export const FocusButton = styled.button `
  border: none;
  background-color: transparent;
  ${FocusLinkButtonTextStyles}
  font-size: ${({ isMobile }) => (isMobile ? '1.125rem' : '1.25rem')};
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  color: ${({ isCrossLink, theme }) => isCrossLink ? theme.colors.primary : theme.colors.darkergrey};

  ${FocusStyles}

  &:hover {
    color: ${({ isCrossLink, theme }) => isCrossLink ? theme.colors['primary-hover'] : theme.colors.primary};
  }
`;
export const FocusLink = forwardRef(function InnerFocusLink({ children, className, to, 'data-testid': dataTestId = 'focus-link', 'data-trackingid': dataTrackingId, onClick, }, ref) {
    const hasReactRouterContext = useHasReactRouterContext();
    if (hasReactRouterContext) {
        return (React.createElement(LinkWithOutline, { "data-testid": dataTestId, "data-trackingid": dataTrackingId, as: Link, className: className, ref: ref, to: to, onClick: onClick }, children));
    }
    else {
        return (React.createElement(LinkWithOutline, { "data-testid": dataTestId, "data-trackingid": dataTrackingId, className: className, href: to, ref: ref, onClick: onClick }, children));
    }
});
FocusLink.defaultProps = {
    'data-testid': 'focus-link',
    'data-trackingid': undefined,
    onClick: undefined,
};
